import { Icon } from '../icon';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { GetIcon } from './IconManager';
import { InfoTrial } from './TreeMenu';
import { T } from './helpers';
import { ContainerSubscription, ContainerTextSubscribe, ImgArrowRight, TextDayTrial, TextSubscribe } from './leftAppSidebarStyles';

const ContainerTrialAlert = styled.div`
    display: flex;
    width: 100%;
    justify-content: start;
    margin-bottom: 10px;
`;

const GoToPage = () => {
    window.location.href = '/Admin/Seller/UpgradeTrialSubscription';
};

const TrialAlert: FunctionComponent<InfoTrial> = (props) => {
    return (
        <ContainerTrialAlert>
            <TextDayTrial>{props.daysOfTrial}</TextDayTrial>
            <ContainerTextSubscribe>
                {T._('Days Left in trial', 'Admin')}
                {props.isVisibleSubscribePlan && (
                    <ContainerSubscription onClick={GoToPage}>
                        <TextSubscribe>{T._('Subscribe plan', 'Admin')}</TextSubscribe>
                        <ImgArrowRight>
                            <Icon>{GetIcon('arrow_right_solid') && React.createElement(GetIcon('arrow_right_solid')!)}</Icon>
                        </ImgArrowRight>
                    </ContainerSubscription>
                )}
            </ContainerTextSubscribe>
        </ContainerTrialAlert>
    );
};

export default TrialAlert;
